// extracted by mini-css-extract-plugin
export default {"tx":"_82c6d4307d","line":"_2ee9947106"};